import React, { useState } from 'react';
import LoginPage from './LoginPage';
import OpeningSequence from './OpeningSequence';
import GalleryPage from './GalleryPage';

export default function App() {
  const [loggedIn, setLoggedIn]           = useState(false);
  const [hasOpenedGift, setHasOpenedGift] = useState(false);

  if (!loggedIn) {
    return <LoginPage onLogin={() => setLoggedIn(true)} />;
  }

  if (!hasOpenedGift) {
    return <OpeningSequence onOpenGift={() => setHasOpenedGift(true)} />;
  }

  return (
    <GalleryPage 
      onLogout={() => {
        setLoggedIn(false);
        setHasOpenedGift(false);
      }} 
    />
  );
}
